// extracted by mini-css-extract-plugin
export default {"wrapper":"Kq-z","response":"Lq-z","error":"Mq-z","disabled":"Nq-z","buttons":"Oq-z","feedbackQuestionSection":"Pq-z","yesNoWrapper":"Qq-z"};